<template>
  <div class="account-container">
    <div class="account-header">
      <h1 class="account-title">
        <v-icon class="title-icon">{{ pageIcon }}</v-icon>
        {{ pageName }}
      </h1>
    </div>
    <div class="account-content">
      <PageTabs :tabs="tabs" :startTab="tabFromQuery" :showArrows="$vuetify.breakpoint.xs" />
    </div>
  </div>
</template>
<script>
import DataService from '../../../_services/DataService';
import PageTabs from '../../components/PageTabs.vue';
import UserInfo from './UserInfo.vue';
import AccountInfo from './AccountInfo.vue';
import ManageFamily from './ManageFamily.vue';
import ContactPrefs from './ContactPrefs.vue';
import PatientForm from '../PatientForm.vue';
import PrivacyConsent from './PrivacyConsent.vue';

export default {
  name: 'UserDashboard',
  components: {
    PageTabs,
    UserInfo,
    AccountInfo,
    ManageFamily,
    ContactPrefs,
    PatientForm,
    PrivacyConsent,
  },
  data() {
    return {
      pageName: 'Account Settings',
      pageIcon: 'mdi-account-cog',
      tabFromQuery: null,
      loading: true,
      tabs: [],
      patient: [
        {label: 'Patient Info', section: UserInfo},
        {label: 'Account Info', section: AccountInfo},
        {label: 'Contact Preferences', section: ContactPrefs},
        {label: 'Forms', section: PatientForm},
      ],
      clientAdmin: [
        {label: 'Account Info', section: AccountInfo},
        {label: 'Contact Preferences', section: ContactPrefs},
      ],
      clientUser: [
        {label: 'Account Info', section: AccountInfo},
        {label: 'Contact Preferences', section: ContactPrefs},
      ],
    };
  },
  methods: {
    async loadPatient() {
      const patientResp = await DataService.getPatientInfo();
      if (patientResp.status === 200) {
        if (!patientResp.data.isSubAccount) {
          this.tabs.push({label: 'Manage Family', section: ManageFamily});
        }

        this.tabs.push({label: 'Privacy & Consent', section: PrivacyConsent});
      }
    },
  },
  async mounted() {
    switch (DataService.getRole()) {
    case 'clientAdmin':
      this.tabs = this.clientAdmin;
      break;
    case 'patient':
      this.tabs = this.patient;
      await this.loadPatient();
      break;
    case 'clientUser':
      this.tabs = this.clientUser;
      break;
    default:
      this.tabs = [];
    }

    if (this.$route.query.tab) {
      const lowerRoute = this.$route.query.tab.toLowerCase();
      const tabIndex = this.tabs.findIndex((tab) => tab.label.toLowerCase() === lowerRoute);
      if (tabIndex !== -1) {
        this.tabFromQuery = tabIndex;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
@import '@/scss/mixins/_mobile-nav-spacing.scss';

// Component-specific colors
$account-title-color: #2d3748;
$account-title-icon-color: #6b7280;
$account-content-bg-color: #ffffff;
$account-content-border-color: #e2e8f0;

.account-container {
  padding: 16px !important;
  background-color: transparent !important;
  
  @media (max-width: $breakpoint-mobile) {
    padding: 12px !important;
  }

  @include mobile-nav-spacing;

  .account-header {
    display: none;

    .account-title {
      display: flex !important;
      align-items: center !important;
      font-size: 24px !important;
      font-weight: 600 !important;
      color: $account-title-color !important;
      margin: 0 !important;
      font-family: 'Inter', sans-serif !important;
  
      .title-icon {
        font-size: 28px !important;
        color: $account-title-icon-color !important;
        margin-right: 12px !important;
      }
  
      @media (max-width: $breakpoint-mobile) {
        font-size: 20px !important;
    
        .title-icon {
          font-size: 24px !important;
        }
      }
    }
  }

  .account-content {
    background-color: $account-content-bg-color !important;
    border-radius: 12px !important;
    box-shadow: $shadow-md !important;
    border: 1px solid $account-content-border-color !important;
    overflow: hidden !important;
    padding: 0 !important;
  }
}
</style>
